import React from 'react'
import CategoryBar from '../Home/homeComponents/CategoryBar'
import FinalBanner from '../Home/homeComponents/FinalBanner'
import CategoryBarForMobile from '../Home/homeComponents/CategoryBarForMobile'
import NavneetSoftwares from './NavneetSoftwaresHome'
import Fashion from '../Home/homeComponents/Fashion'
import Bestselling from '../Home/homeComponents/Bestselling'
import Appliances from '../Home/homeComponents/Appliances'
import Electronics from '../Home/homeComponents/Electronics'
import Groceries from '../Home/homeComponents/Groceries'
import BeforeFooter from '../Home/homeComponents/BeforeFooter'
import { Box } from '@chakra-ui/react'
import TopOffers from '../Home/homeComponents/TopOffersRecommended'
import RecomendaseBooks from '../Home/homeComponents/RecomendaseBooks'

const RecommendedLink = () => {
    
    return (
        <Box>
            <CategoryBarForMobile />
            <NavneetSoftwares/>
            <TopOffers />
            {/* <RecomendaseBooks/> */}
            <BeforeFooter />
        </Box>
    )
}

export default RecommendedLink